import styled from "styled-components";
import ClientDataSection from "./components/client-data-section";
import ClientAddressSection from "./components/client-address-section";
import SessionService from "../../../services/session-service";
import { useEffect, useState } from "react";
import { ClientData } from "../../../services/users/get-logged/types";
import { theme } from "../../../helpers/theme";

export const ClientAccount = () => {
  const [clientData, setClientData] = useState<ClientData>(
    SessionService.getLoggedUserData()
  );

  
  return (
    <PageContainer>
      <ClientDataSection clientData={clientData} />
      <ClientAddressSection clientData={clientData} />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${theme.device.Mlaptop} {
    align-items: center;
    gap: 30px;
    width: 100%;
    margin-bottom: 40px;
  }
  @media ${theme.device.laptop} {
    flex-direction: row;
    width: 78%;
    margin-left: 250px;
    justify-content: space-evenly;
  }
`;
